var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-12 dashboard", attrs: { flat: "" } },
    [
      _c(
        "v-row",
        _vm._l(_vm.menus, function(menu) {
          return _c(
            "v-col",
            {
              key: menu.header,
              attrs: { elevation: "2", cols: "12", md: "4", sm: "12" }
            },
            [
              menu.gate === undefined || _vm.checkGate(menu.gate)
                ? _c(
                    "v-card",
                    [
                      _c("v-subheader", { attrs: { inset: true } }, [
                        _vm._v(
                          "\n          " + _vm._s(menu.header) + "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-navigation-drawer",
                        { attrs: { floating: "", permanent: "" } },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "", rounded: "" } },
                            [
                              _vm._l(menu.items, function(item) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: item.title,
                                    attrs: { to: item.path, link: "" }
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.title))
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c("v-list-item")
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }